import React, { useCallback } from 'react'
import { Platform, View, TouchableOpacity } from 'react-native'
import { Title } from 'react-native-paper'
import Modal from '../atoms/Modal'
import { IconCloseDrawer, CloseIcon } from '../../assets/icons'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export type IconClosePos = 'title' | 'absolute' | 'none'

type Props = {
  title?: string
  onClose: () => void
  visible: boolean
  children: React.ReactNode
  containerStyle?: any
  titleIcon?: React.ReactNode
  contentStyle?: any
  backDropAction?: boolean
  iconClosePos?: IconClosePos
  modalStyle?: any
  titleStyle?: any
  testID?: string
  animationIn?: string
  animationOut?: string
}

export default ({
  title = '',
  onClose,
  visible,
  children,
  containerStyle = {},
  titleIcon = '',
  contentStyle = {},
  backDropAction = true,
  iconClosePos = 'title',
  modalStyle = {},
  titleStyle = {},
  testID = 'modal',
  animationIn = 'fadeIn',
  animationOut = 'fadeOut',
}: Props) => {
  const onKeyDown = useCallback(
    (event) => {
      if (event.keyCode === 27 && backDropAction && visible) {
        onClose()
      }
    },
    [backDropAction, visible, onClose],
  )

  React.useEffect(() => {
    if (Platform.OS === 'web') {
      document.addEventListener('keydown', onKeyDown, false)
    }

    return () => {
      if (Platform.OS === 'web') {
        document.removeEventListener('keydown', onKeyDown, false)
      }
    }
  }, [onKeyDown])

  return (
    <Modal
      backDropAction={backDropAction}
      visible={visible}
      onClose={onClose}
      animationIn={animationIn}
      animationOut={animationOut}
      animationInTiming={400}
      style={composeStyle({ borderRadius: 8 }, modalStyle)}
    >
      <View
        style={composeStyle(
          {
            backgroundColor: 'white',
            borderRadius: 10,
            alignSelf: 'center',
            minWidth: 300,
          },
          containerStyle,
        )}
        testID={testID}
      >
        {iconClosePos === 'absolute' && (
          <TouchableOpacity onPress={onClose}>
            <CloseIcon style={{ right: 5, top: 5, position: 'absolute' }} />
          </TouchableOpacity>
        )}
        {!!title && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              padding: 20,
              borderRadius: 10,
              zIndex: -1,
            }}
          >
            {titleIcon}
            <Title
              style={composeStyle(
                {
                  flex: 1,
                  marginLeft: titleIcon ? 10 : 0,
                },
                titleStyle,
              )}
            >
              {title}
            </Title>
            {iconClosePos === 'title' && (
              <TouchableOpacity onPress={onClose}>
                <IconCloseDrawer />
              </TouchableOpacity>
            )}
          </View>
        )}
        <View style={[{ padding: 10 }, contentStyle]}>{children}</View>
      </View>
    </Modal>
  )
}
